<template>
  <button class="btn btn-car" @click="$emit('click', $event)" :style="style">
    <icon class="btn-icon" v-if="icon" :name="icon" :fill="iconColor || 'white'" />
    <slot></slot>
  </button>
</template>

<script>
  export default {
    props: {
      bgColor: null,
      icon: null,
      iconColor: null,
      textColor: null
    },
    computed: {
      style() {
        let styleString = ''
        if(this.textColor){
          styleString += 'color: ' + this.textColor + ';\n'
        }
        if(this.bgColor){
          styleString += 'background-color: ' + this.bgColor + ';\n'
        }
        return styleString
      }
    }
  }
</script>

<style>
.btn-car {
  width: 100%;
  margin: 0;
  border-radius: 0;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.333333px;
  padding: 10px 2px 6px;
}
.btn-car + .btn-car {
  margin: 0;
}
.btn-car:first-child {
  box-shadow: none;
  border-top: 1px solid #e8e8e8;
}
.btn-car:last-child {
  border-radius: 0 0 8px 8px;
}
</style>